import { useEffect, useState } from 'react'

import PropTypes from 'prop-types'
import { StyledTable } from 'components'
import { useGetUserNewsTipTableColumns } from 'domains/User/hooks'

const UserNewsTipsTable = (props) => {
  const { dataSource } = props

  /* Pagination params for table */
  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 30,
    total: 0,
    showQuickJumper: true,
    showSizeChanger: true
  })

  /* Getting table columns */
  const columns = useGetUserNewsTipTableColumns()

  /* Handle changes for table */
  const handleTableChange = (pagination) => {
    setTableParams(pagination)
  }

  /* Update total value for tableParams */
  useEffect(() => {
    dataSource?.length &&
      setTableParams((prev) => ({
        ...prev,
        total: dataSource?.length
      }))
  }, [dataSource])

  return (
    <StyledTable
      tableOuterHeight={690}
      {...props}
      rowKey="_id"
      columns={columns}
      pagination={tableParams}
      onChange={handleTableChange}
    />
  )
}
UserNewsTipsTable.propTypes = {
  dataSource: PropTypes.array
}

export default UserNewsTipsTable
